enum ActionTypes {
	request = 'DatasourceComputedPrice.request',
	receive = 'DatasourceComputedPrice.receive',
}

export default ActionTypes;
